const features = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '同步日本和国内播出进度，最快2小时内更新最新番剧，追番不再等待，第一时间看到最新剧情。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '全站支持1080P超清画质播放，部分热门番剧提供4K选项，给你影院级的视觉享受。',
  },
  {
    id: 3,
    icon: 'ri-download-cloud-2-line',
    title: '高速下载',
    desc: '多线路CDN加速下载，支持批量下载和断点续传，离线追番随时随地想看就看。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全无删减',
    desc: '所有番剧均为完整版，无删减无和谐，保留原汁原味的剧情体验，专注纯粹的动漫内容。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么数百万动漫迷选择91樱花？看看我们的核心优势
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature, idx) => (
            <div
              key={feature.id}
              className="group bg-background-100 rounded-2xl p-6 md:p-7 border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 text-center"
            >
              <div
                className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl mx-auto mb-5 transition-colors duration-300 ${
                  idx % 2 === 0
                    ? 'bg-accent-100 group-hover:bg-accent-200'
                    : 'bg-primary-100 group-hover:bg-primary-200'
                }`}
              >
                <i
                  className={`${feature.icon} text-xl md:text-2xl ${
                    idx % 2 === 0 ? 'text-accent-600' : 'text-primary-600'
                  }`}
                ></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}